import { useContext } from "react";
import { deadlines } from "../../config";
import "./style.scss";
import RegistrationContext from "../../contexts/RegistrationContext";

function Footer() {
 
  return (
      
        <footer className="bg-white shadow-inner mt-auto">
        <div className="container mx-auto px-4 py-4 text-sm text-gray-500 flex flex-wrap justify-center md:justify-between items-center">
          <div>
            <span>Copyright © IJCAI</span>
            <span className="mx-2">•</span>
            <span>
              Contact us at{" "}
              <a href="mailto:registrationy@ijcai.org" className="text-blue-600 hover:underline transition-colors">
                registration@ijcai.org
              </a>
            </span>
          </div>
          <div>
            <span>
              IJCAI Privacy Policy (
              <a href="https://registration.ijcai.org/IJCAIPrivacyPolicy.pdf" target="_blank"  className="text-blue-600 hover:underline transition-colors">
                PDF
              </a>
              )
            </span>
          </div>
        </div>
      </footer>
  );
}

export default Footer;
